export const boost = {
    fontFamilyImport: [],
  transitionMain: "all 300ms ease-in-out",

  fieldTopSpacing: 22,
  inputPaddingInline: 10,

  inputHeight: 45,
  inputWidth: '100',
  inputWidthUnits: "%",

  inputFontSize: 14,
  inputFontFamily: '"Montserrat", sans-serif',
  inputColor: "#000000",
  inputBackgroundColor: "transparent",
  inputFontWeight: 500,

  inputBorderColor: "#C6C6C6",
  inputBorderWidth: 1,
  inputBorderRadius: 0,

  inputHoverColor: "#000000",
  inputHoverBorderColor: "#C6C6C6",
  inputHoverBackgroundColor: "transparent",

  // **********************************
  //  Select field
  selectTopSpacing: 22,
  selectPaddingInline: 10,

  selectHeight: 45,
  selectWidth: '100',
  selectWidthUnits: "%",

  selectFontSize: 14,
  selectFontFamily: '"Montserrat", sans-serif',
  selectColor: "#000000",
  selectBackgroundColor: "transparent",
  selectFontWeight: 500,

  selectBorderColor: "#C6C6C6",
  selectBorderWidth: 1,
  selectBorderRadius: 0,

  selectHoverColor: "#000000",
  selectHoverBorderColor: "#C6C6C6",
  selectHoverBackgroundColor: "transparent",

  addSelectBackgroundImage: false,
  selectBackgroundImage: '',
  selectBackgroundImagePositionRight: 10,
  selectBackgroundImageSize: 20,

  // **********************************
  //  Text Area field
  textAreaTopSpacing: 22,
  textAreaPaddingInline: 10,

  textAreaHeight: 45,
  textAreaWidth: '100',
  textAreaWidthUnits: "%",

  textAreaFontSize: 14,
  textAreaFontFamily: '"Montserrat", sans-serif',
  textAreaColor: "#000000",
  textAreaBackgroundColor: "transparent",
  textAreaFontWeight: 500,

  textAreaBorderColor: "#C6C6C6",
  textAreaBorderWidth: 1,
  textAreaBorderRadius: 0,

  textAreaHoverColor: "#000000",
  textAreaHoverBorderColor: "#C6C6C6",
  textAreaHoverBackgroundColor: "transparent",

  // **********************************
  //  placeholder
  placeholderColor: "#C6C6C6",
  placeholderFontFamily: '"Montserrat", sans-serif',
  placeholderFontSize: 14,
  placeholderFontWeight: 400,
  placeholderHoverColor: "#C6C6C6",

  // **********************************
  // script
  addPlaceholders: false,
  removeFieldLabels: false,

  // **********************************
  //  field label
  fieldLabelBottomSpacing: 3,
  fieldLabelPadding: 0,
  fieldLabelFontSize: 14,
  fieldLabelColor: "#000",
  fieldLabelFontWeight: 500,
  fieldLabelColorAsterisk: "#BF4914",
  fieldLabelAlignment: "column",
  fieldLabelFontFamily: '"Montserrat", sans-serif',

  // **********************************
  //  description
  descriptionPaddingInline: 0,
  descriptionColor: "#000",
  descriptionFontSize: 14,
  descriptionFontWeight: 500,
  descriptionFontFamily: '"Montserrat", sans-serif',
  descriptionTopSpacing: 5,

  // **********************************
  // checkbox

  addCheckbox: false,
  checkedCheckboxContent: "",
  checkboxInputSize: 30,
  checkboxBorderWidth: 1,
  checkboxBorderRadius: 0,
  checkboxUncheckedBorderColor: "#C6C6C6",
  checkboxUncheckedBackgroundColor: "#FFFFFF",
  checkboxCheckedBackgroundColor: "#F2B844",
  checkboxCheckedBorderColor: "#C6C6C6",
  checkboxCheckedColor: "#fff",
  checkboxAlignment: "none",
  checkboxLabelFontFamily: '"Montserrat", sans-serif',
  checkboxLabelFontSize: 14,
  checkboxLabelFontWeight: 500,
  checkboxLabelColor: "#000000",

  // **********************************
  // radio button

  addRadioButton: false,
  radioInputSize: 30,
  radioBorderWidth: 1,
  radioBorderRadius: 50,

  radioUncheckedBorderColor: "#C6C6C6",
  radioUncheckedBackgroundColor: "#fff",
  radioCheckedBackgroundColor: "#F2B844",
  radioCheckedBorderColor: "#C6C6C6",

  radioAlignment: "none",

  radioLabelFontFamily: '"Montserrat", sans-serif',
  radioLabelFontSize: 14,
  radioLabelFontWeight: 500,
  radioLabelColor: "#000",

  // **********************************
  // submit button

  submitMarginTop: 32,
  submitFontSize: 17,
  submitFontFamily: "'Montserrat', sans-serif",
  submitWidth: 175,
  submitWidthUnits: "px",
  submitHeight: 46,
  submitBorderRadius: 0,
  submitBorderWidth: 1,
  submitBackground: "#F2B844",
  submitColor: "#fff",
  submitBorderColor: "#F2B844",
  submitBackgroundHover: "#F2B844",
  submitBorderColorHover: "#F2B844",
  submitColorHover: "#fff",
  submitTextAlign: "center",
  submitButtonText: "Submit",
  submitFontWeight: 500,
  addBackgroundImage: false,
  submitBackgroundImage: '',
  submitBackgroundImagePositionRight: 10,
  submitBackgroundImageSize: 20,
  submitButtonAlign: "left",
};

  